import { render, staticRenderFns } from "./AttachAnswerModal.vue?vue&type=template&id=5e1dd682&scoped=true"
import script from "./AttachAnswerModal.vue?vue&type=script&lang=js"
export * from "./AttachAnswerModal.vue?vue&type=script&lang=js"
import style0 from "./AttachAnswerModal.vue?vue&type=style&index=0&id=5e1dd682&prod&lang=scss"
import style1 from "./AttachAnswerModal.vue?vue&type=style&index=1&id=5e1dd682&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1dd682",
  null
  
)

export default component.exports